<div class="modal-header">
  <h6 class="modal-title" i18n>Edit Listing Settings</h6>
  <a (click)="close()" class="cstm-close">
    <span class="far fa-times"></span>
  </a>
</div>
<div class="modal-body p-0">
  <form [formGroup]="form">
    <div class="p-3 border-bottom">
      <div class="row">
        <div class="col-sm-6">
          <mat-form-field2 class="mat-block">
            <input
              matInput
              placeholder="Landlord Name"
              i18n-placeholder
              formControlName="landlordName"
              type="text"
              required
            />
            <mat-error *ngIf="form.get('landlordName').touched && form.get('landlordName').hasError('required')">
              <ng-container i18n>Landlord Name is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-sm-6">
          <mat-form-field2 class="mat-block">
            <input
              matInput
              placeholder="Landlord Email"
              i18n-placeholder
              formControlName="landlordEmail"
              type="email"
              required
            />
            <mat-error *ngIf="form.get('landlordEmail').touched && form.get('landlordEmail').hasError('required')">
              <ng-container i18n>Landlord Email is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-sm-6">
          <mat-form-field2 class="mat-block">
            <input
              matInput
              placeholder="Landlord Phone"
              i18n-placeholder
              formControlName="landlordPhone"
              type="text"
              required
            />
            <mat-error *ngIf="form.get('landlordPhone').touched && form.get('landlordPhone').hasError('required')">
              <ng-container i18n>Landlord Phone is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-sm-6">
          <mat-form-field2 class="mat-block">
            <input
              matInput
              placeholder="Check-in Location"
              i18n-placeholder
              formControlName="checkInOutPlace"
              type="text"
              required
            />
            <mat-error *ngIf="form.get('checkInOutPlace').touched && form.get('checkInOutPlace').hasError('required')">
              <ng-container i18n>Value is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
      </div>
    </div>
    <div class="p-3 border-bottom">
      <div class="row">
        <div class="col-sm-3">
          <mat-form-field2
            class="mat-block"
            matTooltip="The amount of days before arriving in which the guest should contact the landlord"
            i18n-matTooltip
          >
            <input
              matInput
              placeholder="Days Before Arrival"
              i18n-placeholder
              formControlName="daysBeforeArrival"
              type="number"
              step="1"
              required
            />
            <mat-error
              *ngIf="form.get('daysBeforeArrival').touched && form.get('daysBeforeArrival').hasError('required')"
            >
              <ng-container i18n>Value is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-sm-3">
          <mat-form-field2
            class="mat-block"
            matTooltip="If it's a house and providing floor info does not make much sense, you can just put 1"
            i18n-matTooltip
          >
            <input
              matInput
              placeholder="Floor number"
              i18n-placeholder
              formControlName="floor"
              type="number"
              required
            />
            <mat-error *ngIf="form.get('floor').touched && form.get('floor').hasError('required')">
              <ng-container i18n>Value is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-sm-6">
          <mat-form-field2 class="mat-block">
            <mat-select formControlName="depositTypeId" placeholder="Deposit Type" i18n-placeholder required>
              <mat-option *ngFor="let item of rentalsUnitedDepositTypes" [value]="item.id">{{ item.label }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('depositTypeId').touched && form.get('depositTypeId').hasError('required')">
              <ng-container i18n>Value is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-sm-6">
          <mat-form-field2 class="mat-block">
            <textarea
              matInput
              placeholder="Cancellation Policy Text"
              i18n-placeholder
              formControlName="cancellationPolicyText"
              rows="3"
            ></textarea>
          </mat-form-field2>
        </div>
        <div class="col-sm-3">
          <mat-form-field2 class="mat-block">
            <input
              matInput
              placeholder="Deposit Amount"
              i18n-placeholder
              formControlName="depositAmount"
              type="number"
              required
            />
            <mat-error *ngIf="form.get('depositAmount').touched && form.get('depositAmount').hasError('required')">
              <ng-container i18n>Value is required</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('depositAmount').hasError('min')">
              <ng-container i18n>Min value is 0</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('depositAmount').hasError('max')">
              <ng-container i18n>Max value is 100</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
      </div>
    </div>
    <div class="p-3">
      <h6 i18n>Cancellation Policy</h6>
      <div formArrayName="cancellationPolicy" *ngFor="let item of cancelPolicies.controls; let i = index">
        <div [formGroupName]="i" class="row">
          <div class="col-sm-3">
            <mat-form-field2 class="mat-block">
              <input type="number" formControlName="validFrom" matInput required placeholder="From" i18n-placeholder />
              <mat-hint i18n>days before arrival</mat-hint>
              <mat-error *ngIf="item.get('validFrom').touched && item.get('validFrom').hasError('required')">
                <ng-container i18n>Value is required</ng-container>
              </mat-error>
              <mat-error *ngIf="item.get('validFrom').hasError('max')">
                <ng-container i18n>From should be less than To</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-sm-3">
            <mat-form-field2 class="mat-block">
              <input type="number" formControlName="validTo" matInput required placeholder="To" i18n-placeholder />
              <mat-hint i18n>days before arrival</mat-hint>
              <mat-error *ngIf="item.get('validTo').touched && item.get('validTo').hasError('required')">
                <ng-container i18n>Value is required</ng-container>
              </mat-error>
              <mat-error *ngIf="item.get('validTo').hasError('min')">
                <ng-container i18n>To should be greater than From</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-sm-4">
            <mat-form-field2 class="mat-block">
              <input
                type="number"
                formControlName="totalPricePercent"
                matInput
                required
                placeholder="Charge (0%-100%)"
                i18n-placeholder
              />
              <mat-hint i18n>of total booking amount</mat-hint>
              <mat-error
                *ngIf="item.get('totalPricePercent').touched && item.get('totalPricePercent').hasError('required')"
              >
                <ng-container i18n>Value is required</ng-container>
              </mat-error>
              <mat-error *ngIf="item.get('totalPricePercent').hasError('min')">
                <ng-container i18n>Value should be greater than 0</ng-container>
              </mat-error>
              <mat-error *ngIf="item.get('totalPricePercent').hasError('max')">
                <ng-container i18n>Value should be less than 100</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-sm-2">
            <button
              matTooltip="Remove"
              matTooltipPosition="above"
              i18n-matTooltip
              (click)="onRemoveCancelPolicy(i)"
              type="button"
              class="btn btn-secondary-danger align-input-row-end"
              *ngIf="!!i"
            >
              <i class="cs-icon cs-icon-trash"></i>
            </button>
          </div>
        </div>
      </div>
      <div i18n *ngIf="cancelPolicies.hasError('overlap')" class="text-danger mb-3">
        Cancellation policy period(s) should not overlap.
      </div>
      <div class="mt-3">
        <button class="btn btn-secondary-info" (click)="onAddCancelPolicy()">
          <i class="far fa-plus"></i> <ng-container i18n>Add Penalty</ng-container>
        </button>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline-light">
    <span class="far fa-times"></span>
    <ng-container i18n>Cancel</ng-container>
  </button>
  <button *ngIf="isEditing" (click)="onSave(form)" type="button" class="btn btn-secondary-info">
    <span class="cs-icon cs-icon-save"></span>
    <ng-container i18n>Save</ng-container>
  </button>
  <button *ngIf="!isEditing" (click)="onCreate(form)" type="button" class="btn btn-secondary-info">
    <span class="cs-icon cs-icon-save"></span>
    <ng-container i18n>Create</ng-container>
  </button>
</div>
